import React, {useState, useEffect} from 'react'
import axiosInstance from './../../http/axios';

import Toast from '../../toast';
import Header from './../header/Header';

import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css"

import ArrowBackRounded from '@mui/icons-material/ArrowBackRounded';
import { IconButton } from '@mui/material';
import DropdownMenu from '../dropdown_menu/DropdownMenu';
import {Pagination} from '@mui/material';
import AddRounded from '@mui/icons-material/AddRounded';
import { NavLink } from 'react-router-dom';
import Switch from '../switch/Switch';

const Gift = () => {

     const naviagte = (a)=> {
          if(typeof a == 'string'){
               window.location.href = a;
          }
          else if(typeof a == 'number'){
               window.history.go(a);
          }
     };

     const [data, setData] = useState([]);
     const [maxLength, setMaxDataLength] = useState(0);
     const [errorMessage, setErrorMessage] = useState(null);
     const tableHead = ["Gift", "Name", "Category", "Value", "Status", "Created at", ""];

     const onPageChange = async (e, pageIndex) => {
          try {
               const params = new URLSearchParams();
               params.append("skip", 20 * (pageIndex-1));
               params.append("limit", 20);

               const res = await axiosInstance.get('admin/gifts', {
                    params: params
               });
               setErrorMessage(null);
               setData(res.data.data);
               setMaxDataLength(res.data.maxLength);
          } 
          catch (error) {
               setErrorMessage("Failed");
               console.log(error);
          }
     }

     useEffect(async ()=>{
          onPageChange(null, 1);
     }, []);

     return (
          <>
               <Header/>
               <div className="d-flex justify-content-between">
                    <div style={{height: '80px'}} className='d-flex align-items-center'>
                         {/* <IconButton onClick={()=>naviagte(-1)}><ArrowBackRounded/></IconButton> */}
                         <h5  style={{marginLeft: '10px', height: '100%', marginTop: '5px'}} className='d-flex align-items-center'>Gifts</h5>
                    </div>
                    <div className="d-flex align-items-center">
                         <div className='banner_create' onClick={()=> naviagte('/admin-create-gift')}>
                              <AddRounded style={{color: '#fff'}}/>
                              <button>Create</button>
                         </div>
                    </div>
                    {/* <DropdownMenu items={["Active users", "Blocked users"]} onChange={(value, i)=> {
                              const status = i == 0 ? "active" : "blocked";
                              setUserAccountStatus(status);
                              onPageChange(null, 0, status);
                         }}/> */}
               </div>
               <div className="__table_root">
                    <table cellspacing="0" cellpadding="0" className="table">
                    <tr>
                         { tableHead.map((value, i)=> <th>{value}</th>) }
                    </tr>
                    { errorMessage ? null : ( data.length != 0 ? data.map((value, i)=> <Item data={value} position={i}/>) : null) }
                    </table>
                    { data.length != 0 ? null : <ErrorMessage message='Empty'/> }
                    { errorMessage ? <ErrorMessage message={errorMessage}/> : null }
                    <div className='d-flex justify-content-between'>
                    <div></div>
                         <Pagination onChange={onPageChange} count={maxLength != 0 ? ~~((maxLength/20)+1) : 0} shape="rounded" />
                    </div>
               </div>
          </>
     );
}

const Item = (props) => {
     const { _id, name, category, url, giftImage, enabled, price, date } = props.data;

     const [checked, setChecked] = useState(enabled);

     const naviagte = (a)=> {
          if(typeof a == 'string'){
               window.location.href = a;
          }
          else if(typeof a == 'number'){
               window.history.go(a);
          }
     };

     const onCheckedChange = async (checked) => {
          setChecked(checked)
          try {
               const rBody = new FormData();
               rBody.append("id", _id)
               rBody.append("enabled", checked)
               const res = await axiosInstance.patch("admin/gift", rBody, 
                    {
                         headers: { "Content-Type": "multipart/form-data" }
                    }
               )
          } 
          catch (error) {
               Toast.error("Failed to update");
               setChecked(!checked);
          }
     }

     useEffect(()=> {
          setChecked(enabled)
     }, [enabled]);

     return(
          <tr>
               <td><img src={url&&!url.endsWith("svga")?url:giftImage} alt="gift" style={{borderRadius: '0px', width: '60px', height: '60px'}}/></td>
               <td>
                    {/* <NavLink to="/" a className={isActive => "nav_link " + (isActive ? "" : "navlink_unselected")}> */}
                         {name}
                    {/* </NavLink> */}
               </td>
               <td><span>{category.charAt(0).toUpperCase() + category.slice(1)}</span></td>
               <td><span className={"item_status_view status_c_yellow"}>{price + " Diamonds"}</span></td>
               {/* <td><span className={"item_status_view " + (enabled ? "status_c_green" : "status_c_red")}>{enabled ? "Enabled" : "Desabled"}</span></td> */}
               <td><Switch onChange={(checked)=>{onCheckedChange(checked)}} checked={checked} /></td>
               <td>{date}</td>
               <td><button onClick={()=>naviagte("/admin-edit-gift?id=" + _id)} style={{background: "green", border: "none", color: "white", padding: "5px 15px", borderRadius: "5px"}} >Edit</button></td>
          </tr>
     );
};

const ErrorMessage = (props) => {
     return (
          <div className='d-flex align-items-center justify-content-center' style={{height: "300px", fontSize: '16px'}}>
               {props.message}
          </div>
     );
}

export default Gift;